/**
 * MyGemaPro APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ContractorScopesDto { 
    contractorId: string;
    contractorName: string;
    scopes: Array<ContractorScopesDto.ScopesEnum>;
}
export namespace ContractorScopesDto {
    export type ScopesEnum = 'BUILDING_BASE_DATA' | 'BUILDING_INSPECTIONS' | 'BUILDING_TGAS' | 'BUILDING_SENSORS' | 'BUILDING_SCANS' | 'BUILDING_DOCUMENTS' | 'BUILDING_EQUIPMENT_DOCUMENTS';
    export const ScopesEnum = {
        BuildingBaseData: 'BUILDING_BASE_DATA' as ScopesEnum,
        BuildingInspections: 'BUILDING_INSPECTIONS' as ScopesEnum,
        BuildingTgas: 'BUILDING_TGAS' as ScopesEnum,
        BuildingSensors: 'BUILDING_SENSORS' as ScopesEnum,
        BuildingScans: 'BUILDING_SCANS' as ScopesEnum,
        BuildingDocuments: 'BUILDING_DOCUMENTS' as ScopesEnum,
        BuildingEquipmentDocuments: 'BUILDING_EQUIPMENT_DOCUMENTS' as ScopesEnum
    };
}


